import { trackClick } from 'js/utils/trackClick';

function track(action: string, data?: Record<string, unknown>): void {
  trackClick({
    source: `research_radar.${action}`,
    extra: data,
  });
}

export function trackTopicCardClicked(topicId: number): void {
  track('topic_card_clicked', { topic_id: topicId });
}

export function trackTopicCreated(
  topicId: number,
  source: 'modal' | 'intermediate' | 'suggestion',
): void {
  track('topic_created', { topic_id: topicId, source });
}

export function trackWeeklyEmailToggled(
  topicId: number,
  enabled: boolean,
): void {
  track('weekly_email_toggled', { topic_id: topicId, enabled });
}

export function trackPaperClicked(
  topicId: number,
  workId: number,
  strategy: string,
  position: number,
): void {
  track('paper_clicked', {
    topic_id: topicId,
    work_id: workId,
    strategy,
    position,
  });
}

export function trackPaperMarkedRead(topicId: number, workId: number): void {
  track('paper_marked_read', { topic_id: topicId, work_id: workId });
}

export function trackMarkAllRead(topicId: number, count: number): void {
  track('mark_all_read', { topic_id: topicId, count });
}

export function trackTabSwitched(topicId: number, tab: 'new' | 'all'): void {
  track('tab_switched', { topic_id: topicId, tab });
}

export function trackDownloadPdfPack(topicId: number): void {
  track('download_pdf_pack', { topic_id: topicId });
}

export function trackDownloadNew(topicId: number, count: number): void {
  track('download_new', { topic_id: topicId, count });
}

export function trackSuggestionTrackClicked(workId: number): void {
  track('suggestion_track_clicked', { work_id: workId });
}

export function trackCreateModalOpened(step: 1 | 2): void {
  track('create_modal_opened', { step });
}

export function trackEditModalOpened(topicId: number): void {
  track('edit_modal_opened', { topic_id: topicId });
}

export function trackTopicEdited(
  topicId: number,
  fieldsChanged: string[],
): void {
  track('topic_edited', { topic_id: topicId, fields_changed: fieldsChanged });
}

export function trackTopicDeleted(topicId: number): void {
  track('topic_deleted', { topic_id: topicId });
}

export function trackNavClicked(source: 'desktop' | 'mobile'): void {
  track('nav_clicked', { source });
}

export function trackIntermediateTrackClicked(sourceWorkId: number): void {
  track('intermediate_track_clicked', { source_work_id: sourceWorkId });
}

export function trackIntermediateDismissed(sourceWorkId: number): void {
  track('intermediate_dismissed', { source_work_id: sourceWorkId });
}

export const IMPRESSION_SOURCES = {
  allRadars: 'research_radar.all_radars',
  topicDetail: 'research_radar.topic_detail',
  zeroState: 'research_radar.zero_state',
  intermediate: 'research_radar.intermediate',
  createModal: 'research_radar.create_modal',
  editModal: 'research_radar.edit_modal',
  suggestion: 'research_radar.suggestion',
} as const;
